export default "__VITE_ASSET__858164d6__"